import React from 'react';
import {
	IconStateAwaiting,
	IconStateCompleted,
	IconStateDelayed,
	IconStateOngoing,
	IconOrderSubmitted,
	IconStateCanceled
} from '../Icons';

const status = {
	AWAITING_APPROVAL: {
		label: 'Auftrag übermittelt', // Order submitted
		icon: <IconOrderSubmitted />,
	},
	ONGOING: {
		label: 'In Bearbeitung', // In progress
		icon: <IconStateOngoing />,
	},
	DELAYED: {
		label: 'Verzögert', // Order delayed
		icon: <IconStateDelayed />,
	},
	COMPLETED: {
		label: 'Fertig', // Completed
		icon: <IconStateCompleted />,
	},
	AWAITING_PAYMENT: {
		label: 'Zahlung ausständig', // Payment pending
		icon: <IconStateAwaiting />,
	},
	CANCELED: {
		label: 'Storniert', // Canceled
		icon: <IconStateCanceled />,
	},
	OFFLINE: {
		label: 'Offline', // Offline
		icon: null,
	},
	ONLINE: {
		label: 'Online', // Online
		icon: null,
	},
};

interface StatusLabelProps {
	id?: string;
	onClick?: () => void;
	children: keyof typeof status;
}

export const StatusLabel: React.FC<StatusLabelProps> = props => {
	const label = status[props.children]?.label ?? props.children;
	return (
		<div
			className={'styled-status ' + props.children}
			id={props.id}
			data-pw={'status-label-' + props.children.toLowerCase().replace(' ', '-')}
			onClick={props.onClick}
			role="button"
		>
			{status[props.children]?.icon}
			{label}
		</div>
	);
};
